import type { IconData } from '@stacksjs/iconify-core'

export const graphDot: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M35 8a5 5 0 1 0 10 0a5 5 0 0 0-10 0m-13 8a5 5 0 1 1-10 0a5 5 0 1 1 10 0m16 12a5 5 0 1 1-10 0a5 5 0 1 1 10 0\"/><path d=\"M3.5 35c2.908-5.51 7.316-11.395 10.297-15.13m6.944-.505c2.769 2.287 5.745 4.392 8.071 5.951m5.572-2.088c1.24-3.954 2.64-7.75 3.732-10.564\"/><path d=\"M3 3c0 16.305.301 32.309.436 38.65a2.97 2.97 0 0 0 2.914 2.914C12.691 44.699 28.695 45 45 45\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default graphDot
